import React from 'react';

import Logo from '../../../components/UI/Logo/Logo';
import Hamburger from '../../../components/UI/Hamburger/Hamburger';

import styles from './Header.module.css';

const NavItem = (props) => {
  return <li className={styles.NavigationItem}><a href={props.link}>{props.label}</a></li>
}

const NavButton = (props) => (
  <li className={styles.NavigationItem}><button onClick={props.callback}>{props.label}</button></li>
)
const Header = (props) => {
  return (
    <header className={styles.Toolbar}>
      <Hamburger menu={props.menu}/>
    <div className={styles.TBLogo}>
      <div className={styles.Logo}>
        <a href="/submit"><Logo /></a>
      </div>
    </div>
    <nav className={styles.DesktopOnly}>
      <ul className={styles.NavigationItems}>
        { props.menu.map( (e) => (
          ('callback' in e ) 
          ? <NavButton key={Math.random()} label={e.label} callback={e.callback} />
          : <NavItem key={Math.random()} label={e.label} link={e.link} />
        )) }
      </ul>
    </nav>
  </header>
)}

export default Header;

//<img height="26" width="26" class="mr-2" src="<%# = image_url('logo_RXOME_small.png') %>">